import { SlideObjectStyle } from '../types';

function strokeDashAttrs(kind: SlideObjectStyle['strokeDash'], strokeWidth: number): string {
  if (kind === 'dashed') {
    const dash = Math.max(3, strokeWidth * 2);
    return ` stroke-dasharray="${dash} ${dash}"`;
  }
  if (kind === 'dotted') {
    const gap = Math.max(6, strokeWidth * 2.4);
    return ` stroke-linecap="round" stroke-dasharray="0.01 ${gap}"`;
  }
  return '';
}

export function shapeSvgMarkup(
  width: number,
  height: number,
  style?: SlideObjectStyle,
  paint: { fill?: boolean; stroke?: boolean } = { fill: true, stroke: true },
): string {
  const kind = style?.shape || 'rect';
  const useFill = paint.fill !== false;
  const useStroke = paint.stroke !== false;
  const fill = !useFill || !style?.backgroundColor || style.backgroundColor === 'transparent' ? 'none' : style.backgroundColor;
  const stroke = !useStroke ? 'none' : (style?.strokeColor || 'none');
  const strokeWidth = useStroke ? Math.max(0, Number(style?.strokeWidth || 0)) : 0;
  const dashAttrs = strokeDashAttrs(style?.strokeDash, strokeWidth);
  const inset = strokeWidth / 2;
  const attrs = `fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}"${dashAttrs} vector-effect="non-scaling-stroke"`;

  let inner = '';
  if (kind === 'line') {
    if (height > width) {
      const x = width / 2;
      inner = `<line x1="${x}" y1="${inset}" x2="${x}" y2="${Math.max(inset, height - inset)}" ${attrs} />`;
    } else {
      const y = height / 2;
      inner = `<line x1="${inset}" y1="${y}" x2="${Math.max(inset, width - inset)}" y2="${y}" ${attrs} />`;
    }
  } else if (kind === 'ellipse') {
    inner = `<ellipse cx="${width / 2}" cy="${height / 2}" rx="${Math.max(1, width / 2 - inset)}" ry="${Math.max(1, height / 2 - inset)}" ${attrs} />`;
  } else if (kind === 'triangle') {
    inner = `<polygon points="${width / 2},${inset} ${width - inset},${height - inset} ${inset},${height - inset}" ${attrs} />`;
  } else if (kind === 'roundRect' || ((kind === 'rect' || !kind) && (style?.cornerRadius || 0) > 0)) {
    const radius = style?.cornerRadius != null ? style.cornerRadius : Math.min(width, height) * 0.12;
    inner = `<rect x="${inset}" y="${inset}" width="${Math.max(1, width - strokeWidth)}" height="${Math.max(1, height - strokeWidth)}" rx="${radius}" ${attrs} />`;
  } else {
    inner = `<rect x="${inset}" y="${inset}" width="${Math.max(1, width - strokeWidth)}" height="${Math.max(1, height - strokeWidth)}" ${attrs} />`;
  }

  return `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 ${Math.max(1, width)} ${Math.max(1, height)}" preserveAspectRatio="none">${inner}</svg>`;
}
